<template>
    <div class="table-outer-box">
        <div class="table table-theme table-flex">
            <div class="item" v-for="(item, key) in tableThemes" :key="key">{{ item.title }}</div>
        </div>
        <div class="scroll-div flex-column" scroll-y="true" bindscrolltolower="loadMore">
            <div class="tableContent" v-for="(items, keys) in tableItems" :key="keys">
                {{ items.value }}
            </div>
        </div>

    </div>

</template>
<script type="text/ecmascript-6">
export default {

    props: {
        tableThemes: Array,
        tableItems: Array,
    },

    // props: ["tableThemes", "tableItems"],

    watch: {
        tableItems: {
            handler: function (val) {
                // console.log(val)
            },
            deep: true,
        },
    },
    data() {
        return {

        }
    },

    created() {
        // console.log(tableThemes)
        // console.log(tableItems)

    },
}

</script>
<style scoped lang="less">
.table-outer-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: -1px;
}

.table {
    height: 80rpx;
    line-height: 80rpx;
    border-top: 1rpx solid #D3D3D3;
    border-bottom: 1rpx solid #D3D3D3;
    text-align: center;
}

.table-flex {
    display: flex;
}

.table-theme {
    font-size: 14px;
    padding: 8px 0;
    color: #D3D3D3;
    border-bottom: 1px solid #eaeaea;
}

.item {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
    color: black;
}

.scroll-div {
    margin: 5px;
    // border-bottom: 1px solid #eaeaea;
}

.tableContent {
    width: 20%;
    height: 30px;
    float: left;
    text-align: center;
    padding: 5px 0;
    color: gray;
    border-bottom:1px solid #eaeaea;
    line-height: 30px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}
</style>


// WEBPACK FOOTER //
// src/components/mtTable.vue